import {ApolloClient, InMemoryCache} from "@apollo/client";
import {WebSocketLink} from "@apollo/client/link/ws";
import {env} from "../env";
import {storage, STORAGE_KEYS} from "../utils/storage";


const createApolloClient = () => {
    const accessToken = storage.get(STORAGE_KEYS.accessToken);
    return new ApolloClient({
        link: new WebSocketLink({
            uri: env.SOCKET_URL,
            options: {
                reconnect: true,
                reconnectionAttempts: 5,
                connectionParams: {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                },
            },
        }),
        cache: new InMemoryCache(),
    });
};

export {createApolloClient};
